function formatDate(dateString) {
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  };
  return date.toLocaleString(undefined, options);
}

export default formatDate;

export const getTimeDifference = (inputDate) => {
  const date = new Date(inputDate);
  const now = new Date();

  const timeDifferenceInSeconds = Math.floor(
    (now - date) / 1000
  );

  if (timeDifferenceInSeconds < 60) {
    return `${timeDifferenceInSeconds} seconds ago`;
  }
  if (timeDifferenceInSeconds < 3600) {
    const minutes = Math.floor(
      timeDifferenceInSeconds / 60
    );
    return `${minutes} ${
      minutes === 1 ? 'minute' : 'minutes'
    } ago`;
  }
  if (timeDifferenceInSeconds < 86400) {
    const hours = Math.floor(
      timeDifferenceInSeconds / 3600
    );
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  }
  if (timeDifferenceInSeconds < 5184000) {
    const days = Math.floor(
      timeDifferenceInSeconds / 86400
    );
    return `${days} ${days === 1 ? 'day' : 'days'} ago`;
  } 
  
  return 'long time ago';
};
